module.exports = Promise.all([parcelRequire.load("l6xiM"), parcelRequire.load("lIUpp")]).then(() => parcelRequire('bLURk'));